import styled from 'styled-components';

export const ADNewLogo = styled.a<{
    marginValue: any;
    widthValue: string;
    heightValue: string;
    flexShrinkValue: any;
}>`
    display: block;
    text-decoration: none;
    width: ${(props) => props.widthValue};
    height: ${(props) => props.heightValue};
    flex-shrink: ${(props) => props.flexShrinkValue};
    margin: ${(props) => props.marginValue};
    cursor: pointer;
    position: relative;
`;

ADNewLogo.defaultProps = {
    marginValue: '0 0 0 0',
    widthValue: '0',
    heightValue: '0',
    flexShrinkValue: '0',
};
